// extracted by mini-css-extract-plugin
export default {"Container":"KfukNP6cT9eSwr4srxcM"};